import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      minHeight: '100vh',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.6rem',
      padding: '1rem',
      '& a': {
        fontSize: '1.5rem',
        marginTop: '.8rem',
      },
    },
    submitButton: {
      marginTop: '1.2rem',
    },
    button: {
      marginTop: '1.2rem',
    },
    swVersion: {
      marginTop: '-.8rem',
    },
    finished: {
      alignSelf: 'center',
      textAlign: 'center',
    },
  }),
)
